import { Select as ViewList } from "../../../components/select";
import { MeioPagViewProps, mapDispatchToMeioPagProps, mapStateToMeioPagProps, meioPagController } from "../meiopg.controll";
import { MeioPag } from "../meiopg.model";
import { Box, Typography } from "@mui/material";
import { formatMoney } from "../../../services/utils";
import { GridColDef } from "@mui/x-data-grid";
import { connect } from "react-redux";
import { memo, useEffect, useState } from "react";
import { FormCad } from "../../../components/viewCadastro/formCad";
import { MeioPagMov } from "../../../data.types";
import Modal from "../../../components/modal";
import { Cancel, Check, Preview } from "@mui/icons-material";
import store from "../../../store";
import { MeioPagList } from "../meiopg.view";

const columns: GridColDef[] = [
    { field: 'descricao', headerName: 'Descricão', flex: 5 },
    { field: 'perc_desc', headerName: 'Desconto', flex: 3, renderCell: (prm) => prm.value + " %" },
    { field: 'obs', headerName: 'Observação', flex: 4 },
]

interface MeioPagListSelectProps extends MeioPagViewProps {
    handleMeioPagSelect: (meioPag: MeioPag) => any
}

function MeioPagListSelect(props: MeioPagListSelectProps) {
    const { handleMeioPagSelect, meioPagActions, meioPagState } = props
    const { row, showAlert, msg, status, rows, loading, changeList } = meioPagState
    const { setShowAlert, read } = meioPagActions

    return (
        <ViewList
            displayWidth={window.innerWidth}
            title={"Meios de pagamento"}
            row={row}
            showAlert={showAlert}
            closeAlert={() => setShowAlert(false)}
            msg={msg}
            status={status}
            elevation={1}
            getRowId={(r) => r._id}
            handleOnChange={handleMeioPagSelect}
            actionsOnkeyEnter={handleMeioPagSelect}
            showSearchContainer={true}
            fontSize={16}
            setTextSearch={() => { }}
            textSearch={""}
            fieldSearch={"descricao"}
            columns={columns}
            rows={rows}
            loading={loading}
            setRow={handleMeioPagSelect}
            variantToobar="dense"
            buttonNew={{
                show: false,
                onClick: () => { }
            }}
            buttonRefresh={{
                show: true,
                onClick: () => read()
            }}
            ListItemTextPrimary={(row: MeioPag) => <Typography component={"span"}>{row.descricao}</Typography>}
            ListItemTextSecondary={(row: MeioPag) => <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography component={"span"}>{row.perc_desc}</Typography>
                <Typography component={"span"}>{row.obs}</Typography>
            </Box>}
            changeList={changeList}
        />
    )
}

interface MeioPagMovSelectProps extends MeioPagViewProps {
    confirme: (value: MeioPagMov) => any
    valor: number
}

function MeioPagMovSelect(props: MeioPagMovSelectProps) {
    const { confirme, valor } = props
    const { setShowSelectModal, read } = props.meioPagActions
    const { showCadModal, rows, showSelectModal } = props.meioPagState
    const [meioPagMov, setMeioPagMov] = useState<MeioPagMov>({ valor: 0 } as MeioPagMov)

    useEffect(() => {
        setMeioPagMov({ valor: 0 } as MeioPagMov)
    }, [valor])

    const handleSetValor = (row: MeioPagMov) => {
        if (row.valor > 0.00)
            setMeioPagMov(row)
        else
            alert(`Valor informado ${row.valor} não é válido!"`);
    }

    const CadMeioPagMov = () => {

        const handleSubmit = (values: MeioPagMov) => {
            confirme(values);
            setShowSelectModal(false);
        }

        const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
            changeValue(state, field, () => value)
        }

        return (
            <FormCad
                handleOnSubmit={handleSubmit}
                //formValidation={}
                handleMutator={() => { }}
                handleCancel={() => { }}
                row={meioPagMov}
                contentForm={[
                    { fieldName: "descricao", label: "Meio Pag.", type: "text", key: "descricao", colunsXS: 8, colunsSM: 8, colunsMD: 8, disabled: true },
                    { fieldName: "valor", label: "Valor", type: "currency", key: "valor", colunsXS: 4, colunsSM: 4, colunsMD: 4, },
                ]}
                buttonActions={[
                    { label: "Cancelar", icon: <Cancel />, color: "warning", variant: "contained", handleOnClick: () => setShowSelectModal(false), disableType: "personalizado", disabled: () => false },
                    { label: "Confirmar", icon: <Check />, color: "success", variant: "contained", handleOnClick: (value) => handleSubmit(value), type: "button", disableType: "personalizado", disabled: () => !(meioPagMov.valor > 0) }
                ]}
            />
        )
    }

    const Content = () => {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <MeioPagListSelect
                    handleMeioPagSelect={(mp) => handleSetValor({ ...mp, valor, sit_pag: "aberto" })}
                    {...props}
                />
                <CadMeioPagMov />
            </Box>
        )
    }

    return (
        <Modal
            component={<Content />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            width="sm"
            heigth="auto"
            handleOnKeyDown={(ev) => {
            }}
        />
    )
}

const MeioPagSelectListMemo = memo((props: MeioPagListSelectProps) => {
        const { showSelectModal, rows } = props.meioPagState
        console.log("render MeioPagSelectList",props);
        useEffect(() => {
            console.log("useEffect MeioPagSelectList",props);
            if (showSelectModal && rows.length === 0)
                props.meioPagActions.read()
        }, [showSelectModal])
        return (
            <Modal
                component={<MeioPagListSelect {...props} />}
                handleClose={() => props.meioPagActions.setShowSelectModal(false)}
                open={props.meioPagState.showSelectModal}
                width="sm"
                heigth="auto"
                handleOnKeyDown={(ev) => {
                }}
            />
        )
    },(prev,next)=>{
        console.log("memo redered",prev.meioPagState.changeList === next.meioPagState.changeList &&
        prev.meioPagState.showSelectModal === next.meioPagState.showSelectModal)
        return prev.meioPagState.changeList === next.meioPagState.changeList &&
        prev.meioPagState.showSelectModal === next.meioPagState.showSelectModal
    }
);

export const MeioPagSelectList = connect(mapStateToMeioPagProps, mapDispatchToMeioPagProps)(MeioPagSelectListMemo)

export default connect(mapStateToMeioPagProps, mapDispatchToMeioPagProps)(MeioPagMovSelect);

export const handleSetShowSelectMeioPagModal = (set: boolean) => {
    store.dispatch(meioPagController.reducer.actions.setShowSelectModal(set))
}